import React from 'react'

import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import { HEADER_CHROME_ID } from '../_helpers/pagination'

/**
 * Cabeçalho das páginas internas. Confirmado por inspeção pixel-a-pixel do PDF-modelo
 * real ("Modelo PGR 2026 - Banco Bradesco_Varejo"): todas as páginas internas trazem
 * apenas o logo Bradesco alinhado à esquerda — sem texto/banner ao lado (o antigo texto
 * "Programa de Gerenciamento de Riscos - PGR" à direita não existe no modelo real, era o
 * banner padrão genérico do Btime).
 *
 * Tipografia: o componente genérico `components/pdf/Text.js` (usado por outras marcas)
 * define a família de fonte inline com prioridade máxima (é o último a sobrescrever no
 * objeto de estilo), então não é possível trocá-la via prop sem editar aquele componente
 * compartilhado. Em vez disso, o bloco de estilo abaixo força Arial/Helvetica apenas
 * dentro de `#pdfPage` — só tem efeito enquanto o documento do PGR Bradesco é o que está
 * montado ali. Fica aqui (não em `PdfDocument.js`) porque o cabeçalho já é o único
 * elemento com garantia de estar dentro da árvore impressa em toda página.
 */
const Header = () => (
  <>
    <style>{`
      #pdfPage, #pdfPage * {
        font-family: Arial, Helvetica, sans-serif !important;
      }
    `}</style>
    {/* `id={HEADER_CHROME_ID}` — o Sumário mede a altura real deste bloco (via
        `_helpers/pagination.js`) para descontar do espaço útil de cada página impressa:
        como este `<thead>` se repete em toda página a partir da 2, ele reduz o conteúdo
        que cabe por página impressa mesmo não se repetendo na tela (fluxo único, sem
        paginação real fora da impressão). Ver `_helpers/pagination.js` para o cálculo. */}
    <div id={HEADER_CHROME_ID} style={{ display: 'block' }}>
      <Image src="/pdfs/bradesco/bradesco-logo.png" maxWidth={110} ignoreFixedSize />
      <Separator weight={10} />
    </div>
  </>
)

export default Header
